/**
 * Start BugSnag to ensure we catch all errors from the start
 */

import { setupBugsnag } from './utilities/bugsnag'

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import Vue from 'vue'

window.Vue = Vue

/// Finish linking bugsnag
setupBugsnag()

/// Add in Vue Components
import VueMoment from '@/plugins/vue-moment'
Vue.use(VueMoment)

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import { Table, TableColumn } from 'element-ui-table'

Vue.use(Table)
Vue.use(TableColumn)

import Notification from './components/ui/Notification'
Vue.prototype.$notify = Notification

import Confirm from './components/ui/Confirm'
Vue.prototype.$confirm = Confirm

Vue.use(require('vue-chartist'))
import 'chartist/dist/chartist.min.css'

import VueHead from 'vue-head'
Vue.use(VueHead, {
    separator: '-',
    complement: 'Spotter'
})

import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

import VueFullscreen from 'vue-fullscreen'
Vue.use(VueFullscreen)

import {plugin} from './router/permissions'
Vue.use(plugin)

require('intersection-observer')
import VueGoogleMaps from 'vue-googlemaps'
Vue.use(VueGoogleMaps, {
    load: {
        apiKey: 'AIzaSyAMUNxsklgAvNXhSd3ZPSLa761kRqWrRqw',
        libraries: ['places'],
        useBetaRenderer: false,
    },
})

// ==============
import './stylus/main.styl'
import './css/table.css'

import AppBadge from './components/ui/_Badge'
import AppButton from './components/ui/_Button'
import AppCollapseItem from './components/ui/_CollapseItem'
import AppDatePicker from './components/ui/_DatePicker'
import AppTag from './components/ui/_Tag'
import AppCard from './components/ui/_Card'
import AppAlert from './components/ui/_Alert'
import AppRadio from './components/ui/_Radio'
import AppRadioGroup from './components/ui/_RadioGroup'
import AppSegmentControl from './components/ui/_SegmentControl'
import Modal from './components/ui/Modal.vue'
import Panel from './components/ui/Panel.vue'
import Heading from './components/ui/Heading.vue'
import Dashboard from './components/ui/Dashboard.vue'
import LinkList from './components/ui/LinkList.vue'
import AppRow from './components/ui/Row.vue'
import AppColumn from './components/ui/Column.vue'
import AppSwitch from './components/ui/_Switch'
import AppCheckbox from './components/ui/_Checkbox'
import AppInput from './components/ui/_Input'
import AppForm from './components/ui/_Form'
import AppFormItem from './components/ui/_FormItem'
import AppTooltip from './components/ui/_Tooltip'
import Popper from './components/ui/_Popper'
import AppSelect from './components/ui/_Select/_Select'
import AppSelectInput from './components/ui/_Select/_SelectInput'
import AppOptionGroup from './components/ui/_Select/_OptionGroup'
import AppOption from './components/ui/_Select/_Option'
import AppSteps from './components/ui/_Steps'
import AppStep from './components/ui/_Step'
import Pagination from './components/ui/Pagination'
import Grid from './components/ui/Grid/_Grid'
import GridItem from './components/ui/Grid/_GridItem'
import ViewportListener from './components/ui/Grid/_ViewportListener'
import ProgressBar from './components/ui/_ProgressBar'

Vue.component(AppBadge.name, AppBadge)
Vue.component(AppButton.name, AppButton)
Vue.component(AppCollapseItem.name, AppCollapseItem)
Vue.component(AppDatePicker.name, AppDatePicker)
Vue.component(AppRadio.name, AppRadio)
Vue.component(AppRadioGroup.name, AppRadioGroup)
Vue.component(AppSegmentControl.name, AppSegmentControl)
Vue.component(AppTag.name, AppTag)
Vue.component(AppCard.name, AppCard)
Vue.component(AppAlert.name, AppAlert)
Vue.component(Modal.name, Modal)
Vue.component(Panel.name, Panel)
Vue.component(Heading.name, Heading)
Vue.component(Dashboard.name, Dashboard)
Vue.component(LinkList.name, LinkList)
Vue.component(AppRow.name, AppRow)
Vue.component(AppColumn.name, AppColumn)
Vue.component(AppSwitch.name, AppSwitch)
Vue.component(AppCheckbox.name, AppCheckbox)
Vue.component(AppInput.name, AppInput)
Vue.component(AppForm.name, AppForm)
Vue.component(AppFormItem.name, AppFormItem)
Vue.component(AppTooltip.name, AppTooltip)
Vue.component(Popper.name, Popper)
Vue.component(AppSelect.name, AppSelect)
Vue.component(AppSelectInput.name, AppSelectInput)
Vue.component(AppOptionGroup.name, AppOptionGroup)
Vue.component(AppOption.name, AppOption)
Vue.component(AppSteps.name, AppSteps)
Vue.component(AppStep.name, AppStep)
Vue.component(Pagination.name, Pagination)
Vue.component(Grid.name, Grid)
Vue.component(GridItem.name, GridItem)
Vue.component(ViewportListener.name, ViewportListener)
Vue.component(ProgressBar.name, ProgressBar)